// @ts-nocheck
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

interface LastUpdateContextType {
  lastUpdateTime: string | null;
  refreshLastUpdateTime: () => Promise<void>;
}

const LastUpdateContext = createContext<LastUpdateContextType | undefined>(undefined);

export const LastUpdateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lastUpdateTime, setLastUpdateTime] = useState<string | null>(null);

  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token') || localStorage.getItem('access_token');
    return { Authorization: `Bearer ${token}` };
  };

  const refreshLastUpdateTime = async () => {
    try {
      // Use hedge-performers endpoint to get timestamp
      const response = await axios.get(`${API_BASE}/api/hedge-performers?timeframe=1Y&limit=1`, {
        headers: getAuthHeaders()
      });

      if (response.data.timestamp) {
        setLastUpdateTime(response.data.timestamp);
      }
    } catch (error) {
      console.error('Failed to fetch last update time:', error);
      // Silently fail - this is not critical
    }
  };

  // Fetch on mount
  useEffect(() => {
    refreshLastUpdateTime();

    // Refresh every minute to check for updates
    const interval = setInterval(refreshLastUpdateTime, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <LastUpdateContext.Provider value={{ lastUpdateTime, refreshLastUpdateTime }}>
      {children}
    </LastUpdateContext.Provider>
  );
};

export const useLastUpdate = () => {
  const context = useContext(LastUpdateContext);
  if (!context) {
    throw new Error('useLastUpdate must be used within LastUpdateProvider');
  }
  return context;
};
